import { useEffect } from 'react';

// Calls onClose when Escape is pressed while active (default true — pass
// false to skip attaching the listener, e.g. while a nested confirm step is
// showing and Escape shouldn't dismiss the whole modal).
export default function useEscapeKey(onClose, active = true) {
  useEffect(() => {
    if (!active) return undefined;
    function handleKeyDown(e) {
      if (e.key === 'Escape' && !e.defaultPrevented) onClose();
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose, active]);
}
